import { jsx as _jsx } from "react/jsx-runtime";
const ModalControls = ({ children }) => {
    return _jsx("div", { className: "px-6 py-4 border-t border-zinc-700", children: children });
};
export default ModalControls;
